module.exports = __webpack_public_path__ + "media/newstyle/images/logo-clube-de-autores-share-e393f6b4651bbc6810b7795db6c7413e.png";